/**
 * alertsDrillStore — état drill-down 3 niveaux module Alertes.
 *
 * PHASE 3.0 UX Revolution (DECISIONS #167).
 * Session-only (pas de persist) — state reset au refresh.
 */

import { create } from 'zustand';

interface AlertsDrillState {
  focusedAlertId: string | null;
  drillLevel: 1 | 2 | 3;
  drillContext: Record<string, unknown>;
  setFocus: (alertId: string) => void;
  setLevel: (level: 1 | 2 | 3) => void;
  goBack: () => void;
  reset: () => void;
}

export const useAlertsDrillStore = create<AlertsDrillState>()((set, get) => ({
  focusedAlertId: null,
  drillLevel: 1,
  drillContext: {},

  setFocus: (alertId) => set({ focusedAlertId: alertId }),

  setLevel: (level) => set({ drillLevel: level }),

  goBack: () => {
    const current = get().drillLevel;
    if (current === 1) {
      set({ focusedAlertId: null, drillLevel: 1, drillContext: {} });
    } else {
      set({ drillLevel: (current - 1) as 1 | 2 });
    }
  },

  reset: () =>
    set({ focusedAlertId: null, drillLevel: 1, drillContext: {} }),
}));
